import { generateCircuitryLogoSvgBlobUrl, ID_CONSTANTS } from '@circuitry-ai/doc-ui';
import { Avatar, Image } from '@nextui-org/react';
import { useMemo } from 'react';

interface ChatLogoProps {
    viewLogo: boolean,
    advisorLogo?: string,
    initials?: string,
    size?: 'md' | 'sm' | 'lg';
}

const ChatLogo = ({ viewLogo, advisorLogo, initials, size = 'md' }: ChatLogoProps) => {
    const defaultAdvisorLogo = useMemo(() => generateCircuitryLogoSvgBlobUrl('#d4007e'), []);
    const imageProps = advisorLogo ? { width: "100%", height: "100%", style: { objectFit: "contain" } } : { width: 18, height: 18 };

    return (
        viewLogo ? (
            <div data-testid="chat-logo-container" className='h-[40px] w-[40px] flex justify-center items-center rounded-full border '>
                <Image id={ID_CONSTANTS.chatAdvisorLogo} alt="advisor-logo" src={advisorLogo ?? defaultAdvisorLogo} {...imageProps} className="card-image z-0" />
            </div>
        ) : (
            <Avatar
                size={size}
                showFallback
                src='https://images.unsplash.com/broken'
                name={initials}
                alt="Profile"
                classNames={{ base: 'bg-[#f0f1f2] text-[#475467]' }}
                data-testid="chat-logo-container"
            />
        )
    );
}

export { ChatLogo }